import api from "../../../services/api";

const APIS = {
  REJECTED_DATA: "/SampleStatus/markAsRemoved",
  RECEIVED_DATA: "/SampleStatus/markAsReceived",
  PRINT_SAMPLES_PDF: "/Sample/getsamplespdfbytes",
};

export const getSampleData = async (
  filterText = "",
  pageNumber = 1,
  pageSize = 25
) => {
  const url = `/scansamples/receivedsamples?PageNumber=${pageNumber}&PageSize=${pageSize}${
    filterText ? `&FilterText=${encodeURIComponent(filterText)}` : ""
  }`;
  const response = await api.get(url);

  return {
    data: response.data || [],
  };
};

export const scanSample = async (
  scanType,
  value,
  pageNumber = 1,
  pageSize = 10
) => {
  try {
    const response = await api.get(
      `/ScanSamples/scan?ScanBy=${scanType}&ScanValue=${encodeURIComponent(
        value
      )}&PageNumber=${pageNumber}&PageSize=${pageSize}`
    );

    if (!response.data) {
      throw new Error("No data received from server");
    }

    return {
      data: response.data.results || [],
      totalCount: response.data.totalRecords || 0,
    };
  } catch (error) {
    console.error("Scan sample error:", error);
    throw error;
  }
};

export const markSampleAsRejected = async (ids) => {
  try {
    const response = await api.post("/SampleStatus/markAsRemoved", ids, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error marking samples as rejected:", error);
    throw error;
  }
};

export const markSampleAsRejectedWithReason = async (ids, comments = "") => {
  try {
    const payload = comments
      ? { sampleIds: ids, comments }
      : ids;

    const response = await api.post("/SampleStatus/markAsRemovedWithReason", payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error marking samples as rejected:", error);
    throw error;
  }
};

export const markSampleAsReceived = async (ids) => {
  try {
    const response = await api.post(
      "/SampleStatus/markAsReceived",
      JSON.stringify(ids),
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error marking samples as received:", error);
    throw error;
  }
};

export const printSamplesPDF = async (samples) => {
  try {
    const ids = samples.map((s) => s.sampleId).join("&ids=");
    const url = `${APIS.PRINT_SAMPLES_PDF}?ids=${ids}`;

    const response = await api.get(url);

    let pdfData;
    if (typeof response.data === "string") {
      pdfData = atob(response.data);
    } else {
      pdfData = response.data;
    }

    const bytes = new Uint8Array(pdfData.length);
    for (let i = 0; i < pdfData.length; i++) {
      bytes[i] = pdfData.charCodeAt(i);
    }

    const blob = new Blob([bytes], { type: "application/pdf" });
    const pdfUrl = window.URL.createObjectURL(blob);

    const printWindow = window.open(
      pdfUrl,
      "_blank",
      "width=900,height=700,scrollbars=yes,resizable=yes"
    );

    if (printWindow) {
      printWindow.onload = () => {
        setTimeout(() => {
          printWindow.focus();
          printWindow.print();
        }, 1000);
      };

      printWindow.onbeforeunload = () => {
        window.URL.revokeObjectURL(pdfUrl);
      };
    } else {
      alert("Please allow popups for this site to print the PDF");
      const link = document.createElement("a");
      link.href = pdfUrl;
      link.download = `samples_${Date.now()}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(pdfUrl);
    }

    return response.data;
  } catch (error) {
    console.error("Failed to print samples PDF:", error);
    throw error;
  }
};
